// extracted by mini-css-extract-plugin
export default {"list":"banner5_list__hGbCm","span_text":"banner5_span_text__tkwPa","text_color":"banner5_text_color__iVGBF","margins":"banner5_margins__7aqds"};